module.exports = __webpack_public_path__ + "media/fonts/SaolDisplay-MediumItalic-d665c72a.otf";